import { render, staticRenderFns } from "./ContentRelevanceScores.vue?vue&type=template&id=5989fa0a&scoped=true&"
import script from "./ContentRelevanceScores.vue?vue&type=script&lang=js&"
export * from "./ContentRelevanceScores.vue?vue&type=script&lang=js&"
import style0 from "./ContentRelevanceScores.vue?vue&type=style&index=0&id=5989fa0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989fa0a",
  null
  
)

/* custom blocks */
import block0 from "./ContentRelevanceScores.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports